import React from "react";
import { ProgressBar } from "./ProgressBar";
import { Circle } from "lucide-react";
import { useResponsiveStyles } from "../../../../styles/useResponsiveStyles";

export const RevenueSection = ({ title, revenue, budget, isYTD = false }) => {
    const { getFontSize, getSectionStyle } = useResponsiveStyles();

    const roundNumber = (num) => {
        if (!num) return 0;
        const parsed = parseFloat(num);
        return isNaN(parsed) ? 0 : Math.trunc(parsed);
    };

    return (
        <div
            className="flex justify-between items-center border border-gray-200 rounded-lg gap-4"
            style={getSectionStyle("client-revenue-section")}
        >
            <div className="flex-1 m-2">
                <ProgressBar
                    revenue={parseFloat(revenue ? revenue : 0)}
                    budget={parseFloat(budget ? budget : 0)}
                    isYtd={isYTD}
                />
            </div>
            <div className="flex-initial w-60">
                <div className="flex items-center gap-2">
                    <Circle
                        size={12}
                        className={
                            isYTD
                                ? "fill-emerald-200 text-emerald-200"
                                : "fill-gray-300 text-gray-300"
                        }
                    />
                    <span
                        className="text-[#4C4E64] font-semibold"
                        style={getFontSize("body1")}
                    >
                        Revenue {title}
                    </span>
                    <span
                        className="text-red-500 font-bold ml-auto"
                        style={getFontSize("stat")}
                    >
                        ₹{roundNumber(revenue)}
                    </span>
                </div>
                <div className="flex items-center gap-2 mt-2">
                    <Circle
                        size={12}
                        className="fill-yellow-200 text-yellow-200"
                    />
                    <span
                        className=" text-[#4C4E64] font-semibold"
                        style={getFontSize("body1")}
                    >
                        Budget {title}
                    </span>
                    <span
                        className="text-[#6D788D] ml-auto font-bold"
                        style={getFontSize("stat")}
                    >
                        ₹{roundNumber(budget)}
                    </span>
                </div>
            </div>
        </div>
    );
};
